// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:38:48

export default {
  "id": "room-sort",
  "slug": "room-sort",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a81ef72ff8e0468b8eaed71f39bc2743-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a81ef72ff8e0468b8eaed71f39bc2743/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Room Sort",
      "description": "Welcome to Room Sort - Floor Plan Game, the ultimate free puzzle game that combines the fun of tangram puzzles with the creativity of home design. In this engaging game, you’ll rearrange room blocks to complete floor plans. Each room connects through doors, so you'll need to place them perfectly to create a cohesive layout.",
      "instructions": "Swap the floor plan to correct positions",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2d"
      ]
    },
    "zh-CN": {
      "title": "房间排序",
      "description": "欢迎来到《房间排序 - 平面布局游戏》，这是一款结合了拼图乐趣与家居设计创意的终极免费益智游戏。在这款引人入胜的游戏中，您将重新排列房间模块以完成平面图。每个房间通过门相连，因此您需要完美放置它们以创建一个连贯的布局。",
      "instructions": "交换楼层布局以正确位置",
      "genres": [
        "谜题"
      ],
      "tags": [
        "二维"
      ]
    },
    "zh-TW": {
      "title": "房間分類",
      "description": "歡迎來到《房間排序 - 樓層計畫遊戲》，這是一款結合了七巧板遊戲樂趣與家居設計創意的終極免費謎題遊戲。在這款引人入勝的遊戲中，您將重新排列房間塊來完成樓層計畫。每個房間都通過門相連，因此您需要將它們完美放置以創造一個完整的佈局。",
      "instructions": "交換平面圖以正確位置",
      "genres": [
        "謎題"
      ],
      "tags": [
        "二維"
      ]
    },
    "zh-HK": {
      "title": "房間排序",
      "description": "歡迎來到房間排序 - 樓層計劃遊戲，這是一款結合了七巧板遊戲樂趣與家居設計創意的終極免費謎題遊戲。在這款引人入勝的遊戲中，您將重新排列房間塊來完成樓層計劃。每個房間都通過門相連，因此您需要將它們完美放置以創造一個完整的佈局。",
      "instructions": "交換樓盤以正確位置",
      "genres": [
        "謎題"
      ],
      "tags": [
        "二維"
      ]
    },
    "ja": {
      "title": "部屋ソート",
      "description": "ようこそ、ルームソート フロアプランゲームへ！タンブラムパズルの楽しみとホームデザインのクリエイティビティを融合した究極の無料パズルゲームです。この魅力的なゲームでは、部屋のブロックを並べてフロアプランを完成させます。各部屋はドアでつながっているので、完璧に配置して一貫したレイアウトを作成する必要があります。",
      "instructions": "フロアプランを正しい位置に並べ替えしてください",
      "genres": [
        "パズル"
      ],
      "tags": [
        "2D"
      ]
    },
    "ko": {
      "title": "실간 정리",
      "description": "웰컴 투 룸 솟 - 플로어 플랜 게임, 탐그램 퍼즐의 재미와 집 설계의 창의성을 결합한 최고의 무료 패ズル 게임입니다. 이 흥미로운 게임에서는 방 블록을 재정렬하여 플로어 플랜을 완성합니다. 각 방은 문을 통해 연결되므로, 일관된 레이아웃을 만들기 위해 완벽하게 배치해야 합니다.",
      "instructions": "지도를 바꾸어 올바른 위치로 정렬하세요",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "2D"
      ]
    },
    "fr": {
      "title": "Chambre de tri",
      "description": "Bienvenue dans Room Sort - Floor Plan Game, le jeu de puzzle gratuit ultime qui combine le plaisir des puzzles de tangram avec la créativité de la conception d'intérieur. Dans ce jeu captivant, vous allez réorganiser des blocs de pièces pour compléter des plans de salle. Chaque pièce est connectée par des portes, donc vous devrez les placer parfaitement pour créer un agencement cohérent.",
      "instructions": "Échangez le plan de pièce pour corriger les positions",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2D"
      ]
    }
  }
};
